import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Salaire from './create-salaire';
import SalaireDeleteModal from './delete-salaire';
import ListSalaires from './list-salaire';
import SalaireDetails from './details-salaire';
import SalairePaiementModal from './paiement-salaire-modal';
import PaymentModal from './relance-salaire-modal';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Salaire} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:salaireGroupId/list`} component={ListSalaires} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:salaireId/details`} component={SalaireDetails} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:salaireId/details/relance-paiement`} component={PaymentModal} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:salaireGroupId/paySalaires`} component={SalairePaiementModal} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:salaireGroupId/delete`} component={SalaireDeleteModal} />
    </Switch>
  </>
);

export default Routes;
